// Calendar.js
import { useState } from 'react';
import { Text, Flex, IconButton, Icon, Center, Input, useColorModeValue } from '@chakra-ui/react';
import { FiCheck, FiEdit3, FiTrash2, FiX } from 'react-icons/fi';
import { BiGridVertical } from 'react-icons/bi';

function Calendar(props) {
  const { calendar, selectedCalendar, setSelectedCalendar, handleUpdateCalendar, handleDeleteCalendar } = props
  const [editing, setEditing] = useState(false)
  const [newLower, setNewLower] = useState(calendar?.lower && calendar.lower)
  const [newUpper, setNewUpper] = useState(calendar?.upper && calendar.upper)

  const selectedIconColor = useColorModeValue('black', 'white')
  return (
      <Flex key={calendar.id}
            flexDir={'row'}
            width='20vw'
            borderWidth={'1px'}
            fontWeight={selectedCalendar?.id === calendar?.id ? 'bold' : 'normal'}
            justify={'space-between'}
            boxShadow={'sm'}
            p={2}
            cursor="pointer"
            onClick={() => setSelectedCalendar(calendar)}
            >
              <Flex>
            <Center>
              <Icon 
                cursor={'grabbing'}
                className='reorder-handle'
                as={BiGridVertical}
                color={selectedCalendar?.id === calendar?.id ? selectedIconColor : 'gray.400'}
                fontSize={'3xl'}
                key={calendar.id}
              />
            </Center>
              {editing ? 
              <Flex flexDir={'row'} align='center'>
                  <Input 
                    value={newLower}
                    onChange={(e) => setNewLower(e.target.value)}
                    autoFocus
                    w='80px'
                    h='30px'
                    >
                  </Input>
                  <Text>&nbsp;-&nbsp;</Text>
                  <Input 
                    value={newUpper}
                    onChange={(e) => setNewUpper(e.target.value)}
                    w='80px'
                    h='30px'

                    >
                  </Input>
                  <IconButton
                    size="md"
                    variant='ghost'
                    icon={<FiCheck/>}
                    colorScheme='green'
                    disabled={calendar.lower == newLower && calendar.upper == newUpper}
                    onClick={() => {
                        handleUpdateCalendar(calendar.id, {lower: newLower, upper: newUpper})
                        setEditing(false)}}
                  ></IconButton>
                   <IconButton
                    size="md"
                    variant='ghost'
                    icon={<FiX/>}
                    colorScheme='red'
                    onClick={() => setEditing(false)}
                  ></IconButton>
                </Flex>
                :
                <Flex flexDir={'row'} align='center'>
                  <Text fontSize='sm'>{calendar.lower}</Text>
                  <Text fontSize='sm'>&nbsp;-&nbsp;</Text>
                  <Text fontSize='sm'>{calendar.upper}</Text>

                  <IconButton
                    size="md"
                    variant='ghost'
                    icon={<FiEdit3/>}
                    colorScheme='green'
                    onClick={() => setEditing(true)}
                  ></IconButton>
                </Flex>
              }    
              </Flex>     
              <IconButton
                size="sm"
                variant='ghost'
                icon={<FiTrash2/>}
                colorScheme='red'
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteCalendar(calendar);
                }}
              >
          </IconButton>
      </Flex>
      
    );
}

export default Calendar;
